export default "__VITE_ASSET__BkxnthzK__"